
define('tpl!taoQtiItem/qtiCreator/tpl/modalFeedback/rule', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <option value=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" ";
  stack1 = (helper = helpers.equal || (depth0 && depth0.equal),options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.name), (depth1 && depth1.condition), options) : helperMissing.call(depth0, "equal", (depth0 && depth0.name), (depth1 && depth1.condition), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">";
  if (helper = helpers.label) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n            ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "selected=\"selected\"";
  }

function program4(depth0,data) {
  
  
  return "style=\"display:none\"";
  }

function program6(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <a title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Add else feedback", options) : helperMissing.call(depth0, "__", "Add else feedback", options)))
    + "\" href=\"#\" class=\"adder feedbackRule-add-else\">else</a>\n    ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n     <div class=\"feedbackRule-then-else\">\n            <span class=\"feedbackRule-desc i\">else</span>\n            <button class=\"btn-info small\" type=\"button\" data-feedback=\"else\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Feedback", options) : helperMissing.call(depth0, "__", "Feedback", options)))
    + "</button>\n            <span class=\"feedbackRule-button-delete icon-bin\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Delete else statement", options) : helperMissing.call(depth0, "__", "Delete else statement", options)))
    + "\" data-role=\"else\"></span>\n        </div>\n    ";
  return buffer;
  }

  buffer += "<div class=\"feedbackRule-container\" data-serial=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <div class=\"feedbackRule-rule-if\">\n        <span class=\"feedbackRule-desc i\">if</span>\n        <select class=\"feedbackRule-condition select2\" data-has-search=\"false\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.availableConditions), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </select>\n        <input class=\"feedbackRule-compared-value score\" type=\"text\" value=\"";
  if (helper = helpers.comparedValue) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.comparedValue); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hideScore), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "/>\n    </div>\n    <div class=\"feedbackRule-then-else\">\n        <span class=\"feedbackRule-desc i\">then</span>\n        <button class=\"btn-info small\" type=\"button\" data-feedback=\"then\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Feedback", options) : helperMissing.call(depth0, "__", "Feedback", options)))
    + "</button>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.addElse), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.feedbackElse), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <span class=\"feedbackRule-button-delete icon-bin\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Delete this modal feedback", options) : helperMissing.call(depth0, "__", "Delete this modal feedback", options)))
    + "\" data-role=\"rule\"></span>\n</div>";
  return buffer;
  });
});

